import React from 'react';
import { motion } from 'framer-motion';
export function JoinSection() {
  return <section className="w-full py-32 px-6 md:px-12 flex justify-center" data-id="element-104">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 1,
      ease: [0.16, 1, 0.3, 1]
    }} className="glass-panel rounded-[3rem] p-10 md:p-20 max-w-4xl w-full text-center relative overflow-hidden" data-id="element-105">
        {/* Decorative background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-pink-300/30 blur-[80px] rounded-full z-0 pointer-events-none" data-id="element-106" />

        <div className="relative z-10" data-id="element-107">
          <h2 className="font-syncopate font-bold text-3xl md:text-5xl text-black tracking-widest mb-4" data-id="element-108">
            JOIN THE LAB
          </h2>
          <p className="text-black/70 font-light text-lg md:text-xl mb-10 max-w-xl mx-auto" data-id="element-109">
            Be the first to experience our exclusive launches, private events,
            and seasonal collections.
          </p>

          <form className="flex flex-col md:flex-row gap-4 max-w-2xl mx-auto" onSubmit={e => e.preventDefault()} data-id="element-110">
            <input type="email" placeholder="Enter your email address" className="flex-grow bg-white/40 border border-white/60 rounded-full px-8 py-4 text-black placeholder:text-black/50 focus:outline-none focus:ring-2 focus:ring-pink-300/50 backdrop-blur-md transition-all" required data-id="element-111" />
            <button type="submit" className="bg-iridescent text-black font-semibold text-sm tracking-widest uppercase px-10 py-4 rounded-full hover:scale-105 transition-transform whitespace-nowrap shadow-lg" data-id="element-112">
              Subscribe
            </button>
          </form>
        </div>
      </motion.div>
    </section>;
}